<div class="mat-elevation-z2">
  <table mat-table [dataSource]="data" class="full-width-table" aria-label="Elements">
    <!-- targetProductGroup Column Target product group--> 
    <ng-container matColumnDef="targetProductGroup">
      <th mat-header-cell *matHeaderCellDef>TARGET PRODUCT GROUP</th>
      <td mat-cell *matCellDef="let row">{{row.productGroupName}}</td>
    </ng-container>

    <!-- eligibleTotal Column -->
    <ng-container matColumnDef="eligibleTotal">
      <th mat-header-cell *matHeaderCellDef>ELIGIBLE (TOTAL)</th>
      <td mat-cell *matCellDef="let row">{{row.matchingDevicesTotal}}</td>
    </ng-container>
   
        <!-- eligibleNow Column -->
    <ng-container matColumnDef="eligibleNow">
      <th mat-header-cell *matHeaderCellDef>ELIGIBLE (NOW)</th>
      <td mat-cell *matCellDef="let row">{{row.matchingDevicesRollout }} </td>
    </ng-container>

            <!-- offered Column -->
    <ng-container matColumnDef="offered">
      <th mat-header-cell *matHeaderCellDef>OFFERED</th>
      <td mat-cell *matCellDef="let row">{{row.devicesOffered }} </td>
    </ng-container>

     <!-- installed Column -->
        <ng-container matColumnDef="installed">
      <th mat-header-cell *matHeaderCellDef>INSTALLED</th>
      <td mat-cell *matCellDef="let row">{{row.devicesInstalled }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <p class="text-body-lg-weight-regular text-container-fg-muted mt-050-rem">Last updated: {{ lastUpdated | formatDateTime }}</p>
</div>
